import Vuex from 'vuex';
import Vue from 'vue';

Vue.use(Vuex);

// Create store
export default new Vuex.Store({
  state: {
    currentMember: null,
    memberProfileFilter: null,
    account: null,
    dataPrivacyPolicy: null,
    headOffice: null,
    currentModule: null,
    moduleSelectedActions: [],
    userIsAdmin: false,
    currentSite: {},
    currentSiteId: null,
    visitingSites: [],
    selectedActions: [],
    membershipPrograms: []
  },

  mutations: {
    setCurrentMember: (state, member) => {
      state.currentMember = member;
    },
    setMemberProfileFilter: (state, filter) => {
      state.memberProfileFilter = filter;
    },

    setAccount: (state, account) => {
      state.account = account;
    },

    setDataPrivacyPolicy: (state, dpp) => {
      state.dataPrivacyPolicy = dpp;
    },

    setHeadOffice: (state, ho) => {
      state.headOffice = ho;
    },

    setCurrentModule: (state, moduleName) => {
      state.currentModule = moduleName;
    },

    setCurrentSite: (state, site) => {
      state.setCurrentSite = site;
      state.setCurrentSiteId = site.id;
    },
    setMembershipPrograms: (state, membershipPrograms) => {
      state.membershipPrograms = membershipPrograms;
    }
  },

  actions: {
    setMemberProfileFilter: (state, filter) => {
      state.commit('setMemberProfileFilter', filter);
    },

    setCurrentMember: (state, member) => {
      state.commit('setCurrentMember', member);
    },

    setAccount: (state, account) => {
      state.commit('setAccount', account);
    },

    setDataPrivacyPolicy: (state, dpp) => {
      state.commit('setDataPrivacyPolicy', dpp);
    },

    setHeadOffice: (state, ho) => {
      state.commit('setHeadOffice', ho);
    },

    setCurrentModule: (state, moduleName) => {
      state.commit('setCurrentModule', moduleName);
    },

    setCurrentSite: (state, payload) => {
      state.commit('setCurrentSite', payload);
    },
    setMembershipPrograms: (state, payload) => {
      state.commit('setMembershipPrograms', payload);
    }
  },

  getters: {
    getCurrentMember: (state) => state.currentMember,
    getMemberProfileFilter: (state) => state.memberProfileFilter,
    getAccount: (state) => state.account,

    getDataPrivacyPolicy: (state) => state.dataPrivacyPolicy,
    getHeadOffice: (state) =>
      state.headOffice != null ? state.headOffice.site_id : null,
    getHeadOfficeId: (state) =>
      state.headOffice != null ? state.headOffice.id : null,

    getModuleSelectedActions: (state) => {
      // let _selectedActions = [];
      if (state.account !== null) {
        const userGroupSystemModules = state.account.modules;

        const module = userGroupSystemModules.find(function (module) {
          if (module.systemModule.name == state.currentModule) return true;
        });

        if (typeof module !== 'undefined') {
          state.selectedActions = module.selected_actions.split('|');
        }
      }

      return state.selectedActions;
    },

    userIsAdmin: (state) => {
      return state.account.user_is_admin;
    },
    membershipPrograms: (state) => {
      return state.membershipPrograms;
    }
  }
});
